import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { RechazosTracesParteIIViewModel } from '../rechazostraces.types';
import { RechazosTracesService } from '../rechazostraces.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';

@Component({
    selector: 'app-rechazostraces-wrapper-parte-ii',
    templateUrl: './rechazostraces-wrapper-parte-ii.component.html',
})
export class RechazosTracesWrapperParteIIComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    tracesParteII: RechazosTracesParteIIViewModel;
    formGroup: FormGroup;

    listUrl = '/importacion/rechazostraces';
    private CHEDPP: string | null;

    isRechazo = false;

    activatedRouteData$ = this.activatedRoute.data.subscribe(data => {
        this.isRechazo = data['isRechazo'] === true;
    });

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        this.CHEDPP = params.get('CHEDPP');
        if (this.CHEDPP) {
            this.getRechazoTracesParteII(this.CHEDPP);
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private globalService: GlobalService,
        protected rechazosTracesService: RechazosTracesService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                ControlDocumentalCheck: null,
                ControlDocumentalResult: '',
                ControlIdentidadCheck: null,
                ControlIdentidadResult: '',
                ControlFisicoCheck: null,
                ControlFisicoResult: '',
                ControlCOICheck: null,
                ControlCOIResult: '',
                Conclusion: '',
                FechaInspeccion: null,
                NombreInspector: '',
                PaisInspector: '',
                NombrePIF: '',
                PaisPIF: '',
                MedidasList: [],
                MotivosList: [],
            }),
        });
    }

    private getRechazoTracesParteII(CHEDPP: string): void {
        this.rechazosTracesService
            .getRechazoTracesParteII(CHEDPP)
            .pipe(
                tap((rechazoTracesParteII: RechazosTracesParteIIViewModel) => {
                    // Accede dinámicamente al objeto correspondiente
                    this.tracesParteII = rechazoTracesParteII;

                    // Verifica si el objeto no es nulo y asigna el valor
                    if (this.tracesParteII !== null) {
                        this.tracesParteII.CHEDPP = this.CHEDPP!;
                        if (this.isRechazo) {
                            this.navMenuService.updateMenuServiceForRechazoTraces(this.tracesParteII?.CHEDPP);
                        } else {
                            this.navMenuService.updateMenuServiceForTrasladoTraces(this.tracesParteII?.CHEDPP);
                        }
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }
}
